import Reveal from '@/components/base/Reveal';
import { heroStats } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section className="w-full border-b border-background-200/70 bg-background-50">
      <div className="mx-auto grid w-full max-w-[1200px] grid-cols-1 items-center gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-2 lg:gap-14">
        <Reveal>
          <div className="flex flex-col items-start">
            <span className="inline-flex items-center gap-2 rounded-full border border-accent-200 bg-accent-50 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-flashlight-line" />
              官方入口 · 通道实时监测
            </span>
            <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-4xl lg:text-[42px]">
              91吃瓜官网入口与APP下载指南
            </h1>
            <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              官方入口哪里找？这里把官网网址、APP下载方式与最新可用地址，整理成一份随手可查的清单。
            </p>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              换网址、找官方通道，照着指引几步就能顺利进场，省时省力直接开吃。
            </p>

            <div className="mt-8 flex w-full flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#address"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-login-circle-line text-base" />
                前往官网入口
              </a>
              <a
                href="#app"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                <i className="ri-download-2-line text-base" />
                下载APP
              </a>
            </div>

            <dl className="mt-10 grid w-full grid-cols-3 gap-4 border-t border-background-200 pt-6">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <dt className="text-xs text-foreground-500">{stat.label}</dt>
                  <dd className="mt-1 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                    {stat.value}
                    {stat.suffix && <span className="ml-0.5 text-xs font-medium text-foreground-500">{stat.suffix}</span>}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="relative">
            <div className="h-[320px] w-full overflow-hidden rounded-lg border border-background-200 md:h-[420px] lg:h-[470px]">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20pop%20art%20illustration%20of%20a%20playful%20popcorn%20bucket%20surrounded%20by%20colorful%20speech%20bubbles%2C%20stars%20and%20hearts%2C%20warm%20sunset%20orange%20and%20golden%20amber%20palette%2C%20flat%20vector%20shapes%2C%20clean%20cream%20background%2C%20energetic%20editorial%20poster%20style%2C%20high%20detail&width=1000&height=1120&seq=gcg-hero-01&orientation=portrait"
                alt="91吃瓜官网入口与APP下载指南配图"
                title="91吃瓜 官网入口 最新地址"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute bottom-4 left-4 flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3 md:left-6">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className="ri-shield-check-line text-lg" />
              </span>
              <div>
                <p className="text-xs text-foreground-500">通道状态</p>
                <p className="text-sm font-medium text-foreground-900">全部入口已校验可用</p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}